"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskMusicclassEnum = void 0;
var AsteriskMusicclassEnum;
(function (AsteriskMusicclassEnum) {
    AsteriskMusicclassEnum["DEFAULT"] = "default";
    AsteriskMusicclassEnum["CELTIC"] = "celtic";
    AsteriskMusicclassEnum["JAZZ"] = "jazz";
    AsteriskMusicclassEnum["CHILLOUT"] = "chillout";
    AsteriskMusicclassEnum["GOODBYE"] = "goodbye";
    AsteriskMusicclassEnum["YESTERDAY"] = "yesterday";
    AsteriskMusicclassEnum["BLUES"] = "blues";
    AsteriskMusicclassEnum["UPBEAT"] = "upbeat";
    AsteriskMusicclassEnum["WALTZ"] = "waltz";
    AsteriskMusicclassEnum["CLAPS"] = "claps";
    AsteriskMusicclassEnum["CHEERFUL"] = "cheerful";
    AsteriskMusicclassEnum["LULLABY"] = "lullaby";
    AsteriskMusicclassEnum["HAPPY"] = "happy";
    AsteriskMusicclassEnum["HIDDEN"] = "hidden";
})(AsteriskMusicclassEnum = exports.AsteriskMusicclassEnum || (exports.AsteriskMusicclassEnum = {}));
